'use client';

import { useExtraClasses } from '@lib/hooks/useExtraClasses';
import Link from 'next/link';
import styles from './button.module.scss';

// type of valid extra classes in the button stylesheet
type extraBtnClasses = 'wider' | 'wider-center' | 'eventButton' | '';


import { ButtonHTMLAttributes, ReactNode } from 'react';

type ButtonProps = {
    href?: string;
    target?: '_blank' | '_self' | '_parent' | '_top';
    extraClasses?: extraBtnClasses[];
    children?: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({
    href,
    target = '_self',
    extraClasses,
    children,
    ...buttonProps
}: ButtonProps) => {
    const isLink = typeof href === 'string';
    const isExternal = isLink && !href!.startsWith('/');
    const extraClassString = useExtraClasses(extraClasses, styles);

    const isDisabled = !!buttonProps.disabled;
    const disabledClass = isDisabled ? styles.disabled : '';
    const btnClassName = `${styles.btn} ${extraClassString} ${disabledClass}`.trim();

    if (isLink) {
        if (isExternal) {
            return (
                <a href={href} target={target} rel="noopener noreferrer">
                    <button
                        className={btnClassName}
                        {...buttonProps}
                    >
                        {children}
                    </button>
                </a>
            );
        }
        return (
            <Link href={href} target={target}>
                <button
                    className={btnClassName}
                    {...buttonProps}
                >
                    {children}
                </button>
            </Link>
        );
    }
    // Standard button
    return (
        <button
            className={btnClassName}
            {...buttonProps}
        >
            {children}
        </button>
    );
};

export default Button;
